import { Stack, Typography } from '@mui/material';
import type { PreviewPositionSlotListItem } from '../../types';
import { buildSecondaryCompetencyLabel } from '../../shared/utils/secondaryCompetencyLabel';

const PositionSlotSecondaryCompetencies = ({ positionSlot }: { positionSlot: PreviewPositionSlotListItem }) => (
  <Stack gap={1}>
    {positionSlot.secondaryCompetencyItems?.map(item => (
      <Typography key={`${item.specializationId}-${item.technologyId ?? ''}`} variant="body1">
        {buildSecondaryCompetencyLabel(item)}
      </Typography>
    ))}
  </Stack>
);

export default PositionSlotSecondaryCompetencies;
